import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import ForLawyers from "@/pages/ForLawyers";
import AdoptionInternationale from "@/pages/AdoptionInternationale";
import Blog from "@/pages/Blog";
import Guides from "@/pages/Guides";
import Videos from "@/pages/Videos";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import { ROUTE_PATHS } from "@/lib/index";

const queryClient = new QueryClient();

const NotFound = () => (
  <Layout>
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-foreground mb-4">404</h1>
        <p className="text-muted-foreground mb-6">Page non trouvée</p>
        <a
          href="#/"
          className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
        >
          Retour à l'accueil
        </a>
      </div>
    </div>
  </Layout>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <HashRouter>
        <Routes>
          <Route path={ROUTE_PATHS.HOME} element={<Layout><Home /></Layout>} />
          <Route path={ROUTE_PATHS.SERVICES} element={<Layout><Services /></Layout>} />
          <Route path={ROUTE_PATHS.ABOUT} element={<Layout><About /></Layout>} />
          <Route path={ROUTE_PATHS.FOR_LAWYERS} element={<Layout><ForLawyers /></Layout>} />
          <Route path={ROUTE_PATHS.ADOPTION} element={<Layout><AdoptionInternationale /></Layout>} />
          <Route path={ROUTE_PATHS.BLOG} element={<Layout><Blog /></Layout>} />
          <Route path={ROUTE_PATHS.GUIDES} element={<Layout><Guides /></Layout>} />
          <Route path={ROUTE_PATHS.VIDEOS} element={<Layout><Videos /></Layout>} />
          <Route path={ROUTE_PATHS.FAQ} element={<Layout><FAQ /></Layout>} />
          <Route path={ROUTE_PATHS.CONTACT} element={<Layout><Contact /></Layout>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;